module.exports = __webpack_public_path__ + "static/media/wifi.210df0f9.png";